import type { Route } from 'vue-router';
import Router from 'vue-router';
import { PathName } from '@getaccept/lib-shared/src/enums/PathNames';
import { ModuleName } from '@getaccept/lib-shared/src/entity/app-modules/enums/app-module';

export class RouterHelper {
  static setDocumentTitle(title: string) {
    document.title = title ? `${title} | GetAccept` : 'GetAccept';
  }

  static isInitialNavigation(from: Route) {
    return from === Router.START_LOCATION;
  }

  static getDefaultPathNameByModule(activeModule: ModuleName) {
    switch (activeModule) {
      case ModuleName.DealRooms:
        return PathName.Rooms;
      case ModuleName.Contracts:
        return PathName.Dashboard;
      default:
        return PathName.NotFound;
    }
  }

  static isComingFromApp = (from: Route) => from.name !== null || from.path !== '/';
}
